import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { TransferLotSyncStatus } from "@/graphql/codegen/graphql"
import { isNil } from "@/utils/utils"

interface TransferLotSyncStatusChipProps {
  status?: TransferLotSyncStatus | null
}

const STATUS_TO_LABEL: Record<TransferLotSyncStatus, string> = {
  [TransferLotSyncStatus.PendingSync]: "Pending Sync",
  [TransferLotSyncStatus.Synced]: "Synced",
  [TransferLotSyncStatus.Failed]: "Failed",
}

const STATUS_TO_CHIP_CLASS: Record<TransferLotSyncStatus, string> = {
  [TransferLotSyncStatus.PendingSync]: "bg-tertiary-yellow-300",
  [TransferLotSyncStatus.Synced]: "bg-tertiary-green-300",
  [TransferLotSyncStatus.Failed]: "bg-secondary-200",
}

export const TransferLotSyncStatusChip: FC<TransferLotSyncStatusChipProps> = ({ status }) => {
  if (isNil(status)) return null

  return (
    <Chip
      className={twMerge("h-[18px] rounded py-0 text-xs", STATUS_TO_CHIP_CLASS[status])}
      label={STATUS_TO_LABEL[status]}
      size='small'
    />
  )
}
